import React from 'react';
import axios from '../../../sagas/axios';

import ModalContentBase from '../modal_content_base';
import ModalConfirm from '../modal_confirm';
import ModalAlert from '../modal_alert';

const UpdateEventParticipationUser = ({
  event,
  eventsPlansUser,
  eventsPlansUserMemberId,
  priceType,
  canRefundManagerUser = false,
  isBlockedByCircle = false,
  isExistingMessageGroup = false,
  hashedCompanyId = null
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const declineEventParticipationRef = React.useRef(null);
  const attendanceConfirmRef = React.useRef(null);
  const refundConfirmRef = React.useRef(null);
  const paymentSettingConfirmRef = React.useRef(null);
  const circleBlockConfirmRef = React.useRef(null);
  const confirmAlertRef = React.useRef(null);
  const newMessageRef = React.useRef(null);

  const useApiCall = React.useCallback(
    ({ url, body, isDeclineEventParticipation = false, method = 'post' }) => {
      axios
        .request({ method, url, data: body })
        .then(() => {
          if (isDeclineEventParticipation) {
            declineEventParticipationRef.current.closeModal();
          }
          confirmAlertRef.current.openModal();
        })
        .catch(() => {
          alert(
            '登録に失敗しました。お時間をおいてからもう一度実行してください。'
          );
          if (isDeclineEventParticipation) {
            declineEventParticipationRef.current.closeModal();
          }
        });
    },
    [declineEventParticipationRef, confirmAlertRef]
  );

  const handleDeclineEventParticipation = React.useCallback(
    canseledReason => {
      const body = {
        events_plans_user_id: eventsPlansUser.id,
        circle_id: event.circle_id,
        user_id: eventsPlansUser.user.id,
        canceled_reason: canseledReason
      };
      const url = '/api/event/decline_event_participation';
      useApiCall({ url, body, isDeclineEventParticipation: true });
    },
    [eventsPlansUser, event]
  );

  const handleAttendancEeventsPlansUser = React.useCallback(
    () => {
      const body = {
        events_plans_user_id: eventsPlansUser.id,
        circle_id: event.circle_id,
        is_attend: !eventsPlansUser.is_attend
      };
      const url = '/api/event/update_event_user_attendance';
      useApiCall({ url, body });
    },
    [eventsPlansUser, event]
  );

  const handlePaymentSettingEventsPlansUser = React.useCallback(
    () => {
      const body = {
        events_plans_user_id: eventsPlansUser.id,
        circle_id: event.circle_id,
        is_paid: !eventsPlansUser.is_paid
      };
      const url = '/api/event/update_event_user_payment';
      useApiCall({ url, body });
    },
    [eventsPlansUser, event]
  );

  const handleRefundEeventsPlansUser = React.useCallback(
    () => {
      const body = {
        events_plans_user_id: eventsPlansUser.id,
        circle_id: event.circle_id,
        user_id: eventsPlansUser.user.id
      };
      const url = '/api/event/refund_event_user';
      useApiCall({ url, body });
    },
    [eventsPlansUser, event]
  );

  const handleCircleBlock = React.useCallback(
    () => {
      const body = {
        circle_id: event.circle_id,
        user_id: eventsPlansUser.user.id
      };
      const url = '/api/circles_users_blocks';
      useApiCall({ url, body });
    },
    [eventsPlansUser, event]
  );

  const handleCircleBlockDelete = React.useCallback(
    () => {
      const body = {
        circle_id: event.circle_id,
        user_id: eventsPlansUser.user.id
      };
      const url = '/api/circles_users_blocks';
      useApiCall({ url, body, method: 'delete' });
    },
    [eventsPlansUser, event]
  );

  const createMessageRoom = React.useCallback(
    () => {
      const url = `${
        event.company_id ? `/community/${hashedCompanyId}` : ''
      }/message/create_direct_message/${eventsPlansUserMemberId}/${
        event.circle_id
      }`;
      window.location.href = url;
    },
    [eventsPlansUserMemberId, event]
  );

  const fullname_disp = user => {
    if (user.is_fullname_hidden && user.is_verified_identity) {
      return `@${user.tunagate_id}(本人確認済)`;
    } else if (!user.is_fullname_hidden && user.is_verified_identity) {
      return `${user.familyname} ${user.firstname}(本人確認済)`;
    } else {
      return `${user.familyname} ${user.firstname}`;
    }
  };

  const DeclineModalContent = () => {
    const [canseledReason, setCanseledReason] = React.useState('');

    return (
      <React.Fragment>
        <div className="modal-view-header">
          <p>ユーザーのイベント参加登録を取り消す</p>
        </div>
        <div className="modal-view-body mt-5 pb-4">
          <p className="text-fz-14px text-fw-bold text-black-50 mt-5 mb-1">
            ユーザーの参加登録取り消し理由をご記入ください（必須）。
          </p>
          <p className="mb-2 text-fz-small text-black-50">
            ※取り消し理由はメッセージで相手に通知されます。
          </p>
          <div className="bg-white">
            <div className="form-group">
              <textarea
                className="p-1 w-100 form-control border"
                rows={3}
                value={canseledReason}
                onChange={e => setCanseledReason(e.target.value)}
                autoFocus
              />
            </div>
          </div>
          <p className="mb-0">
            {eventsPlansUser.user.is_fullname_hidden
              ? ' '
              : `${fullname_disp(eventsPlansUser.user)}さんの `}
            イベント参加を取り消しますか？
          </p>
          {eventsPlansUser.payment_id ? (
            <p className="mb-1 text-fz-small">
              {canRefundManagerUser
                ? '※参加者が支払ったクレジット/AmazonPay決済料金は返金されます。'
                : '※参加者が支払ったクレジット/AmazonPay決済料金は返金されません。'}
            </p>
          ) : null}
          {eventsPlansUser.manager_payment_id ? (
            <p className="mb-1 text-fz-small">
              {canRefundManagerUser
                ? '※サークルが支払ったイベント参加手数料は返金されます。'
                : '※サークルが支払ったイベント参加手数料は返金されません。'}
            </p>
          ) : null}
          {eventsPlansUser.manager_payment_id && !canRefundManagerUser ? (
            <a
              href={`/violation_reports/creator_help/${eventsPlansUserMemberId}/${
                event.id
              }`}
              className="a-button a-button__top a-button--orange width-full mx-auto mt-3"
            >
              参加者を通報して返金を受ける
            </a>
          ) : (
            <button
              className="a-button a-button__top a-button--orange width-full mx-auto mt-3"
              onClick={() => {
                setIsLoading(true);
                handleDeclineEventParticipation(canseledReason);
              }}
              disabled={isLoading || canseledReason === ''}
            >
              {isLoading ? (
                <i className="fas fa-spinner fa-pulse fa-2x fa-fw" />
              ) : (
                'ユーザーの参加登録を取り消す'
              )}
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className="dropdown dropleft">
        <div
          data-toggle="dropdown"
          data-display="static" // Android端末で一番下の要素までスクロールできない問題が発生したため、原因となっているPopper.jsを無効化
          style={{ padding: '20px' }}
        >
          <img
            style={{ padding: '0 2px 0 12px' }}
            id="dropdownMenu"
            src="/assets2019/img/icon_reader.svg"
            alt=""
          />
        </div>
        <div className="dropdown-menu" aria-labelledby="dropdownMenu">
          {eventsPlansUser.canceled_at ? null : (
            <React.Fragment>
              <button
                onClick={() => declineEventParticipationRef.current.openModal()}
                className="dropdown-item btn btn-light"
                type="button"
              >
                参加チケットを取り消す
              </button>
              <button
                onClick={() => attendanceConfirmRef.current.openModal()}
                className="dropdown-item btn btn-light"
                type="button"
              >
                出席登録
              </button>
            </React.Fragment>
          )}
          {priceType === 1 || priceType === 2 ? (
            <button
              onClick={() => paymentSettingConfirmRef.current.openModal()}
              className="dropdown-item btn btn-light"
              type="button"
            >
              支払い登録
            </button>
          ) : null}
          {isExistingMessageGroup ? (
            <a
              href={`${
                event.company_id ? `/community/${hashedCompanyId}` : ''
              }/message/create_direct_message/${eventsPlansUserMemberId}/${
                event.circle_id
              }`}
              className="btn btn-light dropdown-item"
            >
              メッセージ
            </a>
          ) : (
            <button
              onClick={() => newMessageRef.current.openModal()}
              className="dropdown-item btn btn-light"
              type="button"
            >
              メッセージ
            </button>
          )}
          <button
            onClick={() => circleBlockConfirmRef.current.openModal()}
            className="dropdown-item btn btn-light"
            type="button"
          >
            サークルから{isBlockedByCircle ? 'ブロック解除' : 'ブロック'}する
          </button>
        </div>
      </div>
      <ModalContentBase
        ref={declineEventParticipationRef}
        previewContent={<template />}
        modalContent={<DeclineModalContent />}
      />
      <ModalConfirm
        ref={attendanceConfirmRef}
        approveFunc={handleAttendancEeventsPlansUser}
        title={
          eventsPlansUser.user.is_fullname_hidden
            ? ' '
            : `${fullname_disp(eventsPlansUser.user)}さんの出欠変更`
        }
        content={`${
          eventsPlansUser.is_attend ? '欠席' : '出席'
        }に変更しますか？`}
      />
      <ModalConfirm
        ref={refundConfirmRef}
        approveFunc={handleRefundEeventsPlansUser}
        title={
          eventsPlansUser.user.is_fullname_hidden
            ? ' '
            : `${fullname_disp(eventsPlansUser.user)}さんの参加料金を返金`
        }
        content="返金しますか？"
      />
      <ModalConfirm
        ref={paymentSettingConfirmRef}
        approveFunc={handlePaymentSettingEventsPlansUser}
        title={
          eventsPlansUser.user.is_fullname_hidden
            ? ' '
            : `${fullname_disp(eventsPlansUser.user)}さんの参加料金支払い設定`
        }
        content={`${
          eventsPlansUser.is_paid ? '未払い' : '支払い済み'
        }に変更しますか？`}
      />
      <ModalConfirm
        ref={circleBlockConfirmRef}
        approveFunc={
          isBlockedByCircle ? handleCircleBlockDelete : handleCircleBlock
        }
        title={`${
          eventsPlansUser.user.is_fullname_hidden
            ? ''
            : `${fullname_disp(eventsPlansUser.user)}さんの`
        }
          サークルブロック設定`}
        content={`${
          eventsPlansUser.user.is_fullname_hidden
            ? ''
            : `${fullname_disp(eventsPlansUser.user)}さんを`
        }
          サークルから${
            isBlockedByCircle ? 'ブロック解除しますか？' : 'ブロックしますか？このユーザーは次回以降このサークルの新規イベントが非表示になります。'
          }`}
      />
      <ModalConfirm
        ref={newMessageRef}
        approveFunc={createMessageRoom}
        title={'メッセージ'}
        content={'メッセージを開通しますか？'}
      />
      <ModalAlert
        ref={confirmAlertRef}
        approveFunc={() => location.reload()}
        title="お知らせ"
        content="登録が完了しました。"
      />
    </React.Fragment>
  );
};

export default UpdateEventParticipationUser;
